import { hexToCSSFilter } from 'hex-to-css-filter';

const Tint = (hex) => {
  if (!hex) return '';

  try {
    const { filter } = hexToCSSFilter(hex);
    
    return filter.replace(/;\s*$/, '');
  } catch (error) {
    console.error('Invalid hex color:', hex, error);
    return '';
  }
};

export default Tint;
